import URL from '../url'
import Request from '../request'
import { mcpConsentDetailsUrl } from '../../utils/mcp-oauth-handoff'

/**
 * MCP server URL and the connection status of each AI tool in the workspace.
 * @returns {Promise<{ data: { mcpUrl: string, tools: { tool: string, name: string, connected: boolean, connectedByMe: boolean, lastActivityAt: string|null }[] } }>}
 */
export const mcpConnectionsGetService = () =>
  new Request(URL.API, URL.MCP_CONNECTIONS).get()

/**
 * Disconnects the current user's connections with a tool (claude, chatgpt, manus, other).
 */
export const mcpConnectionDisconnectService = tool =>
  new Request(
    URL.API,
    URL.MCP_CONNECTION_BY_TOOL.replace('{tool}', tool),
  ).delete()

/**
 * Describes a pending OAuth `/authorize` request for the consent screen (src/pages/mcp-connect) and
 * issues the single-use consent token the gateway requires to continue it. Authenticated with the
 * user's MCG access token.
 * @param {string} returnUrl validated gateway `/authorize` url.
 * @returns {Promise<{ clientId: string, clientName: string|null, clientNameVerified: boolean, redirectUri: string, redirectHost: string, redirectIsLoopback: boolean, scopes: string[], access: string[], resources: string[], consentToken: string, expiresAt: string }>}
 */
export const mcpConsentDetailsService = returnUrl =>
  new Request('', mcpConsentDetailsUrl(returnUrl)).post({ returnUrl })
